import { Validators } from '@angular/forms';

export function getApplicantFormControls(sections: any[]) {
  const controls: any = {};
  sections.forEach(section => {
    section.fields.forEach((field: any) => {
      const validators = [];
      if (field.required) validators.push(Validators.required);
      if (field.pattern) validators.push(Validators.pattern(field.pattern));
      if (field.maxlength) validators.push(Validators.maxLength(field.maxlength));
      // If you want to support disabled fields:
      const config: any = {
        value: field.default_value ?? '',
        disabled: !!field.is_disabled
      };
      controls[field.control_name] = [config, validators];
    });
  });
  return controls;
}